import { AxiosResponse } from 'axios';

export function extractData<T extends { data: T }>(
  response: AxiosResponse<T>,
): T {
  return response.data.data;
}

export default {};
